module.exports = __webpack_public_path__ + "img/light-mud-decal-01.d0d74dfb.png";